import {
  Box,
  Button,
  Flex,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  useToast,
} from '@chakra-ui/react'
import { CardImage } from '../CardImage'
import { useEffect, useState } from 'react'
import { AiFillFilePdf } from 'react-icons/ai'
import Axios from 'axios'
import { format } from 'date-fns'
import locale from 'date-fns/locale/pt-BR'

export function ViewImage({ item, getListImages, excludeButton }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [paste, setPaste] = useState('')

  const toast = useToast()

  function pasteLink() {
    navigator.clipboard.writeText(item.link_imagem)
    setPaste('Copiado!')
  }

  async function deleteItem() {
    try {
      const response = await Axios.get(`${process.env.REACT_APP_BASE_URL}/site/v2/fluxo-imagem/deletar-arquivo-s3/${item.id_imagem}`)

      toast({
        title: 'Sucesso!',
        description: 'Imagem deletada com sucesso!',
        status: 'success',
        duration: 5000,
        isClosable: true,
        position: 'top-right',
      })

      getListImages()
    } catch (error) {
      console.error(error)
      toast({
        title: 'Erro!',
        description: 'Erro ao deletar imagem!',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top-right',
      })
    }
  }

  useEffect(() => {
    if (paste) {
      setTimeout(() => {
        setPaste('')
      }, 5000)
    }
  }, [paste])

  useEffect(() => {
    setPaste('')
  }, [isOpen])

  return (
    <>
      <Flex
        flexDir="column"
        borderRadius="md"
        boxShadow="0 0 3px rgba(0,0,0,.1)"
        onClick={onOpen}
        cursor="pointer"
        transition="all .2s ease-in-out"
        _hover={{
          boxShadow: '0 0 3px rgba(0,0,0,.3)',
          transform: 'translateY(-2px)',
        }}
        height="250px"
        overflow="hidden"
        bgColor="#f5f5f5"
      >
        <Flex minH="200px" w="100%" justifyContent="center" alignItems="center">
          {item.tipo_arquivo.includes('image') ? (
            <Image src={item.link_imagem} alt="" objectFit="cover" fallbackSrc="https://via.placeholder.com/150" />
          ) : (
            <Flex>
              <AiFillFilePdf size={100} />
            </Flex>
          )}
        </Flex>
        <Box bgColor="#f5f5f5" py={2} px={1} borderTop="1px solid #cecece">
          {item.nome_imagem.length > 20 ? <Box as="span">{item.nome_imagem.substring(0, 20)}...</Box> : <Box as="span">{item.nome_imagem}</Box>}
        </Box>
      </Flex>

      <Modal isOpen={isOpen} onClose={onClose} size="2xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Imagem </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <CardImage item={item} />
            <Flex>
              <Box as="span" fontWeight="bold">
                Upado por
              </Box>
              <Box as="span" ml={2}>
                {item.nome_usuario}
              </Box>
              <Box as="span" ml={2} fontWeight="bold">
                em{' '}
                {format(new Date(item.data_upload), "dd 'de' MMMM 'às' HH:mm", {
                  locale,
                })}
              </Box>
            </Flex>
            <Flex mt="1rem" alignItems="flex-end" justifyContent="flex-end">
              {item.tipo_arquivo.includes('image') ? (
                <Button onClick={pasteLink}>
                  {!paste ? (
                    <>
                      Copiar link <span>🔗</span>
                    </>
                  ) : (
                    <>
                      {paste} <span>🎉</span>
                    </>
                  )}
                </Button>
              ) : (
                <Button as="a" href={item.link_imagem} target="_blank" rel="noopener noreferrer">
                  Abrir <span>📄</span>
                </Button>
              )}

              {excludeButton && (
                <Button ml={2} colorScheme="red" onClick={deleteItem}>
                  Excluir <span>🗑️</span>
                </Button>
              )}
            </Flex>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
